import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { useAccount, useHttp } from 'hooks';
import Banner from 'components/Banner/Banner';
import './BannerContainer.scss';
import useEmailMarketing from 'pages/CreateCampaign/Hooks/useEmailMarketing';
import usePaidTier from 'hooks/usePaidTier';

const BannerContainer = ({ closestClassForBanner, coachDeclinedSubscriptions, pendingApplicationsCount }) => {
  const [bannerTypes, setBannerTypes] = useState([]);
  const [zoomBanner, setZoomBanner] = useState(null);
  const { user } = useAccount();
  const { request } = useHttp();
  const { verifiedSendingAddresses } = useEmailMarketing();
  const isSendGridConnected = user?.isSendGridConnected;
  const { isLaunchPlan } = usePaidTier();
  const [cancelledMembershipsDetails, setCancelledMembershipsDetails] = useState([]);

  useEffect(() => {
    getZoomDetails();
  }, []);

  useEffect(() => {
    getClientCancelledMembership();
  }, []);

  const getZoomDetails = useCallback(() => {
    request('/Zoom/CheckIfZoomIsConnected', 'GET')
      .then(res => {
        setZoomBanner(res);
      })
      .catch(console.dir);
  }, [request]);

  const getClientCancelledMembership = useCallback(() => {
    request('/Contribution/GetCancelledMembershipsByCoachNotViewed', 'GET')
      .then(res => {
        setCancelledMembershipsDetails(res);
      })
      .catch(console.dir);
  }, [request]);
  const handleNoShowBanner = ({ id, isViewedByCoach }) => {
    request(
      `/Contribution/UpdateCancelledMembership?cancelledMembershipId=${id}&isViewedByCoach=${isViewedByCoach}`,
      'PUT',
    )
      .then(res => {
        if (res === 'Cancelled membership updated successfully')
          setCancelledMembershipsDetails(prevState => prevState.filter(d => d.id !== id));
      })
      .catch(console.dir);
  };

  const getType = useCallback(() => {
    const types = [];
    if (zoomBanner === false) {
      types.push('zoomConnected');
    }
    if (isLaunchPlan && user?.havePaidTierPurchase) {
      types.push('paymentFailed');
    }
    if (user.standardAccountTransfersEnabled === false && user.isStandardAccount === true) {
      types.push('standardAccountTransfersEnabled');
    }
    if (!user.isEmailConfirmed) {
      types.push('email');
    }

    if ((!user.transfersEnabled || !user.payoutsEnabled) && user.connectedStripeAccountId != null) {
      types.push('bankInfo');
    }
    if (isSendGridConnected && verifiedSendingAddresses?.length > 0 && !user.address) {
      types.push('address');
    }

    if (!isEmpty(closestClassForBanner)) {
      types.push('closestSession');
    }
    if (user.transfersEnabled) {
      types.push('testVideo');
    }
    // if (!user.isSocialSecurityCheckPassed && user.isFirstAcceptedCourseExists && !user.connectedStripeAccountId) {
    //   types.push('socialSecurityInfo');
    // }
    if (user.payoutsEnabled) {
      types.push('moreInfoRequired');
    }
    if (coachDeclinedSubscriptions && coachDeclinedSubscriptions.length > 0) {
      types.push('coachDeclinedSubscriptions');
    }
    if (pendingApplicationsCount) {
      types.push('pendingApplicationsCount');
    }
    if (cancelledMembershipsDetails?.length > 0) {
      types.push('subscriptionCanceled');
    }
    setBannerTypes(types);
  }, [
    user.isEmailConfirmed,
    user.transfersEnabled,
    user.payoutsEnabled,
    user.address,
    closestClassForBanner,
    coachDeclinedSubscriptions,
    user.isSocialSecurityCheckPassed,
    user.standardAccountTransfersEnabled,
    pendingApplicationsCount,
    setBannerTypes,
    zoomBanner,
    setZoomBanner,
    cancelledMembershipsDetails,
  ]);

  useEffect(() => {
    getType();
  }, [getType]);

  return (
    <div className="banners-cohealer">
      {bannerTypes.map(type => (
        <Banner
          type={type}
          closestClassForBanner={closestClassForBanner}
          coachDeclinedSubscriptions={coachDeclinedSubscriptions}
          cancelledMembershipsDetails={cancelledMembershipsDetails}
          handleNoShowBanner={handleNoShowBanner}
        />
      ))}
    </div>
  );
};

BannerContainer.defaultProps = {
  closestClassForBanner: {},
  pendingApplicationsCount: false,
};

BannerContainer.propTypes = {
  closestClassForBanner: PropTypes.shape({
    contributionId: PropTypes.string.isRequired,
    classId: PropTypes.string.isRequired,
    contributionTitle: PropTypes.string.isRequired,
    minutesLeft: PropTypes.number.isRequired,
  }),
  coachDeclinedSubscriptions: PropTypes.shape({}),
  pendingApplicationsCount: PropTypes.bool,
};

export default BannerContainer;
